import React from 'react';
import classNames from 'classnames';

const RejectionCard  = () => {
  function stepClassNames() {
    return classNames(
      "_verticalPadding--xxsmall-mobileOnly",
      "_horizontalPadding--xsmall-mobileOnly",
      "ds-tag",
      "_borderRadius--rounded",
      "_marginRight--small",
      "_fontSize--xxsmall",
      "-primary"
    );
  }

  const liStyle = { "color": "#414141" };

  return (
    <div className="ds-card" data-testid="rejection-card">
      <section className="cardSection">
        <h4 className="-darkBlue _textAlign_center">
          Unfortunately, your business does not meet one or more of our eligibility requirements:
        </h4>
        <h4 className="_textAlign_center"> Your business must: </h4>
        <ul className="_fontSize--small-mobileOnly">
          <li className="_marginBottom--small _displayFlex _alignItems-center ">
            <span className={stepClassNames()}> <strong> 1 </strong> </span>
            <p style={liStyle}>
              Sell to <strong> corporations </strong> or <strong> government agencies/units </strong> in the Philippines
            </p>
          </li>
          <li className="_marginBottom--small _displayFlex _alignItems-center ">
            <p style={liStyle}>
              <span className={stepClassNames()}> <strong> 2 </strong> </span>
              Be <strong> registered with BIR </strong>  and <strong> DTI or SEC </strong>
            </p>
          </li>
          <li className="_marginBottom--small _displayFlex _alignItems-center ">
            <span className={stepClassNames()}> <strong> 3 </strong> </span>
            <p style={liStyle}>
              Be registered for <strong> at least one year </strong>  (unless your annual revenue is already more than P10 million)
            </p>
          </li>
          <li className="_marginBottom--small _displayFlex _alignItems-center ">
            <span className={stepClassNames()}> <strong> 4 </strong></span>
            <p style={liStyle}>
              Be registered in one of the following regions:
              <strong> NCR, Central Luzon, CALABARZON, Central Visayas, Northern Mindanao, </strong> or <strong>Davao Region </strong>
            </p>
          </li>
          <li className="_marginBottom--small _displayFlex _alignItems-center ">
            <span className={stepClassNames()}> <strong> 5 </strong></span>
            <p style={liStyle}>
              not be looking for a <strong> personal loan </strong>
            </p>
          </li>
          <li className="_marginBottom--small _displayFlex _alignItems-center ">
            <span className={stepClassNames()}> <strong> 6 </strong></span>
            <p style={liStyle}>
              not have bad <strong> credit history </strong>
            </p>
          </li>
        </ul>

        <p className="copy _textAlign_center _fontSize--small"> Also, even if you meet all of the criteria above, we may still reject some businesses on a case-to-case basis. </p>
        <h4 className="_textAlign_center -darkBlue"> If we expand our eligibility criteria in the future, we will let you know. </h4>
      </section>
    </div>
  );
}

export default RejectionCard;



// WEBPACK FOOTER //
// ./src/features/home/components/RejectionCard.js